/**
 * Interpreta texto livre digitado pelo admin num `CampoArea` (mensagem de
 * fechado, condições de pagamento) e renderiza como parágrafos e listas de
 * verdade, em vez de um bloco só com as quebras de linha achatadas — que é o
 * que aconteceria jogando a string direto num `<p>`.
 *
 * Convenções, para o admin escrever sem precisar saber HTML:
 *   - linha em branco separa parágrafos;
 *   - linha começando com "- " ou "* " vira item de lista com marcador;
 *   - linha começando com "1. ", "2. " etc vira item de lista numerada;
 *   - linhas soltas dentro do mesmo parágrafo quebram com <br/>.
 */
export function TextoFormatado({ texto }: { texto: string }) {
  const paragrafos = texto.trim().split(/\n{2,}/);

  return (
    <div className="pilha-2">
      {paragrafos.map((paragrafo, i) => {
        const linhas = paragrafo.split('\n').map((l) => l.trim()).filter(Boolean);
        if (linhas.length === 0) return null;

        const marcadores = linhas.every((l) => /^[-*]\s+/.test(l));
        const numeradas = linhas.every((l) => /^\d+[.)]\s+/.test(l));

        if (marcadores) {
          return (
            <ul key={i} style={{ paddingLeft: 'var(--gap-5)', margin: 0 }}>
              {linhas.map((l, j) => (
                <li key={j}>{l.replace(/^[-*]\s+/, '')}</li>
              ))}
            </ul>
          );
        }

        if (numeradas) {
          return (
            <ol key={i} style={{ paddingLeft: 'var(--gap-5)', margin: 0 }}>
              {linhas.map((l, j) => (
                <li key={j}>{l.replace(/^\d+[.)]\s+/, '')}</li>
              ))}
            </ol>
          );
        }

        return (
          <p key={i} style={{ margin: 0 }}>
            {linhas.map((l, j) => (
              <span key={j}>
                {l}
                {j < linhas.length - 1 && <br />}
              </span>
            ))}
          </p>
        );
      })}
    </div>
  );
}
